import { ListItem as ListItemMui, List as ListMui, withStyles } from '@material-ui/core';

import { colors } from '../../assets';

export const ListStyled = withStyles(() => ({
  root: {
    padding: 0,
  },
}))(ListMui) as typeof ListMui;

export const ListItemStyled = withStyles(() => ({
  root: {
    '&:nth-child(even)': {
      backgroundColor: colors.grey10,
    },
  },
}))(ListItemMui) as typeof ListItemMui;
